// import React, { useState } from "react";
// import Sidebar from "./AppSidebar";
// import TopNavbar from "../Navbar/TopNavbar";
// import "../../assets/css/layout.scss";

// const AppLayout = ({ children, ...props }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

//   return (
//     <div className={`app-layout ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"}`}>
//       <Sidebar {...props} isSidebarOpen={isSidebarOpen} />
//       <div className="main-content">
//         <TopNavbar toggleSidebar={toggleSidebar} {...props} />
//         <div className="page-content">{children}</div>
//       </div>
//     </div>
//   );
// };

// export default AppLayout;

// src/components/Layout/AppLayout.js
import React, { useState } from "react";
import TopNavbar from "../Navbar/TopNavbar";
import AppSidebar from "../Navbar/AppSidebar";
// import "../../assets/css/layout.scss";

const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => setCollapsed(!collapsed);

  return (
    <div className="app-layout">
      <AppSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <div
        className="main-content"
        style={{
          flexGrow: 1,
          marginLeft: collapsed ? "80px" : "250px",
          transition: "margin-left 0.3s ease",
        }}
      >
        <TopNavbar toggleSidebar={toggleSidebar} />
        <div className="page-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AppLayout;

